// extracted by mini-css-extract-plugin
module.exports = {"Grid":"ProductsList_Grid__25a3x","Row":"ProductsList_Row__1WTW_","Column":"ProductsList_Column__39D2f"};